import * as signalR from "@aspnet/signalr";
import _ from "lodash";
import { createAction } from "redux-actions";
import * as AdminEventActions from "../../actions/AdminEventActions";
import { Thunk } from "../../actions/Thunk";
import * as M from "../../models";
import Settings from "../../settings";

const prefix = "EVENT_";

export class Constants {
    public static UPDATED_SUBSCRIBED_RSVP = prefix + "UPDATED_SUBSCRIBED_RSVP";
    public static UPDATED_SUBSCRIBED_TO_RSVP_UPDATES = prefix + "UPDATED_SUBSCRIBED_TO_RSVP_UPDATES";
    public static UPDATED_WEBSOCKET = prefix + "UPDATED_WEBSOCKET";
}

interface SubscribedToRsvpUpdatesPayload {
    eventId: number;
    subscribed: boolean;
}

export const connectWebsocket = (): Thunk => async (dispatch, getState) => {
    const retry = () => setTimeout(async () => {
        await dispatch(connectWebsocket());
    }, 10000);

    let connection: signalR.HubConnection = getState().event.websocket!;

    // if there is an existing connection, stop it
    if (connection)
        return;

    // return if not connected
    if (!getState().conn.connected)
        return;

    await new Promise(async (resolve, reject) => {
        try {
            connection = new signalR.HubConnectionBuilder()
                .withUrl(`${Settings.ServicesUrl}/hubs/events`)
                .configureLogging(signalR.LogLevel.Warning)
                .build();

            connection.start().then(async (obj) => {
                // connection success
                connection.onclose((e) => {
                    console.log("Connection closed", e);
                    dispatch(onWebsocketUpdated(undefined));
                    retry();
                });

                await dispatch(onWebsocketUpdated(connection));
                resolve();
            }, async (connErr) => {
                // error connecting
                console.warn("Error connecting", connErr);
                await dispatch(onWebsocketUpdated(undefined));
                reject();
                retry();
            });
        }
        catch (err) {
            console.warn("Error connecting to websocket server", err);
            await dispatch(onWebsocketUpdated(undefined));
            reject();
            retry();
        }
    });
};

export const subscribeToRsvpUpdates = (eventId: number): Thunk => async (dispatch, getState) => {
    // check if already subscribed
    if (getState().event.subscribedToRsvpUpdates[eventId])
        return;

    let connection = getState().event.websocket;
    if (!connection) {
        await dispatch(connectWebsocket());
        connection = getState().event.websocket;
        if (!connection)
            return;
    }

    try {
        connection.on("RsvpStatusUpdated", (data: M.Event.RsvpStatusUpdate) => {
            console.log("rsvp updates received", data);

            // update seats left
            dispatch(AdminEventActions.updateSubEventSeatsLeft(data.eventId, data.seatsLeft));

            dispatch(onSubscribedRsvpUpdated(data.eventId));
        });

        connection.on("RsvpStatusSubscribed", (evtId) => {
            console.log("subscribed to rsvp updates for event ID", evtId);
            dispatch(onSubscribedToRsvpUpdates(evtId, true));
        });

        await connection.invoke("SubscribeRsvpStatus", eventId);
    }
    catch (err) {
        console.warn("subscribeToRsvpUpdates error", err);
    }
};

export const onSubscribedRsvpUpdated = createAction<number, number>(
    Constants.UPDATED_SUBSCRIBED_RSVP, (eventId) => (eventId),
);

export const onSubscribedToRsvpUpdates = createAction<SubscribedToRsvpUpdatesPayload, number, boolean>(
    Constants.UPDATED_SUBSCRIBED_TO_RSVP_UPDATES, (eventId, subscribed) => ({ eventId, subscribed }),
);

export const onWebsocketUpdated = createAction<signalR.HubConnection | undefined, signalR.HubConnection | undefined>(
    Constants.UPDATED_WEBSOCKET, (websocket) => (websocket),
);



// WEBPACK FOOTER //
// ./src/store/event/EventActions.ts